import { r as registerInstance, c as createEvent, h, g as getElement } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { h as hammer } from './hammer-4fc67034.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import './_commonjsHelpers-ba3f0406.js';

const sliderCss = ":host{position:relative;display:flex}.slim-slider-wrapper{overflow:hidden;text-align:center;height:100%;min-width:100%}.slim-slider-wrapper>div,.slim-slider-wrapper>img,.slim-slider-wrapper>p{width:100%;height:100%;display:flex}.slim-slider-wrapper>div.vertical,.slim-slider-wrapper>img.vertical,.slim-slider-wrapper>p.vertical{flex-direction:column}.slim-slider-wrapper>div.is-animating,.slim-slider-wrapper>img.is-animating,.slim-slider-wrapper>p.is-animating{transition:transform 400ms}.carousel-pagination{display:flex;justify-content:center;align-items:center;position:absolute;bottom:-36px;width:100%;height:35px;z-index:100}:host(:not([dir=\"rtl\"])) .carousel-pagination{left:0}:host([dir=\"rtl\"]) .carousel-pagination{right:0}.carousel-pagination a{width:7px;height:7px;padding:0;margin:0 3px;border-radius:50%;background:#cbcbcb;border:0;outline:none;cursor:pointer}.carousel-pagination a.pointer{cursor:none}.carousel-pagination a:first-child,.carousel-pagination a:last-child{width:12px;height:12px}.carousel-pagination a.active{background:#3dcd58}.carousel-pagination .carousel-pagination__above{bottom:85px}.small-point a{width:6px;height:6px}.small-point a:first-child,.small-point a:last-child{width:4px;height:4px}.small-point a.active{width:6px;height:6px}.carousel-buttons{display:flex;justify-content:center;align-items:center;position:absolute;bottom:50%;width:100%;height:0;z-index:100}:host(:not([dir=\"rtl\"])) .carousel-buttons{left:0}:host([dir=\"rtl\"]) .carousel-buttons{right:0}.carousel-buttons.vertical{bottom:0;width:0;height:100%;z-index:100}:host(:not([dir=\"rtl\"])) .carousel-buttons.vertical{left:28px}:host([dir=\"rtl\"]) .carousel-buttons.vertical{right:28px}.carousel-buttons.vertical button{background:none;border:none;padding:0;outline:inherit;cursor:pointer;position:absolute;-webkit-user-select:none;user-select:none;text-decoration:none;color:rgba(51, 51, 51, 0.5)}.carousel-buttons.vertical button.next,.carousel-buttons.vertical button.prev{cursor:pointer}:host(:not([dir=\"rtl\"])) .carousel-buttons.vertical button.next,:host(:not([dir=\"rtl\"])) .carousel-buttons.vertical button.prev{left:-20px}:host([dir=\"rtl\"]) .carousel-buttons.vertical button.next,:host([dir=\"rtl\"]) .carousel-buttons.vertical button.prev{right:-20px}.carousel-buttons.vertical button.next.disabled,.carousel-buttons.vertical button.prev.disabled{color:rgba(51, 51, 51, 0.3)}.carousel-buttons.vertical button.prev{top:-35px}.carousel-buttons.vertical button.next{bottom:-27px}.carousel-buttons:not(.vertical) button{background:none;border:none;padding:0;outline:inherit;cursor:pointer;font-size:22px;position:absolute;-webkit-user-select:none;user-select:none;text-decoration:none}.carousel-buttons:not(.vertical) button.next,.carousel-buttons:not(.vertical) button.prev{cursor:pointer}.carousel-buttons:not(.vertical) button.next.disabled,.carousel-buttons:not(.vertical) button.prev.disabled{color:rgba(51, 51, 51, 0.3)}.carousel-buttons:not(.vertical) button.next{font-size:56px;color:#626469}:host(:not([dir=\"rtl\"])) .carousel-buttons:not(.vertical) button.next{right:-40px}:host([dir=\"rtl\"]) .carousel-buttons:not(.vertical) button.next{left:-40px}.carousel-buttons:not(.vertical) button.prev{font-size:56px;color:#626469}:host(:not([dir=\"rtl\"])) .carousel-buttons:not(.vertical) button.prev{left:-50px}:host([dir=\"rtl\"]) .carousel-buttons:not(.vertical) button.prev{right:-50px}.small-card a{flex-flow:row-reverse}";

let Slider = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.afterSlimInit = createEvent(this, "afterSlimInit", 7);
    this.afterSlimSlide = createEvent(this, "afterSlimSlide", 7);
    this.timing = 400;
    this.childrenClassName = 'pdp-slider > div, pdp-slider > pdp-product-card';
    this.verticalPan = false;
    this.showButtons = true;
    this.infinite = false;
    this.showPointers = false;
    this.showThumbnails = false;
    this.itemsPerSlide = 1;
    this.differentWidthOfItems = false;
    this.sliderWidth = null;
    this.sliderHeight = null;
    this.activeSlide = 0;
    this.panEnabled = true;
    this.direction = document.documentElement.dir || 'auto';
    this.smallPoint = false;
    this.smallCard = false;
    this.goToNext = (e) => {
      e && e.preventDefault();
      if (this.direction === 'rtl') {
        this.slideTo(Math.ceil(this.current + this.operator));
      }
      else {
        this.slideTo(Math.ceil(this.current - this.operator));
      }
    };
    this.goToPrevious = (e) => {
      e && e.preventDefault();
      if (this.direction === 'rtl') {
        this.slideTo(Math.ceil(this.current - this.operator));
      }
      else {
        this.slideTo(this.current + this.operator);
      }
    };
    this.slideCount = 0;
    this.current = this.activeSlide;
    this.pos = 0;
    this.handleSwipe = (e) => {
      const shiftY = (e.deltaY / this.slideWidth) * 100 > -20;
      const shiftX = (e.deltaX / this.slideHeight) * 100 > -20;
      if (this.panEnabled && (shiftY || shiftX)) {
        !this.verticalPan && this.translateY(this.pos + e.deltaY);
        this.verticalPan && this.translateX(this.pos + e.deltaX);
        if (e.isFinal) {
          if (e.type === 'panleft' || e.type === 'panup') {
            this.goToNext();
          }
          else if (e.type === 'panright' || e.type === 'pandown') {
            this.goToPrevious();
          }
          else {
            this.slideTo(this.current);
          }
        }
        else if (e.type === 'panend' || e.type === 'pancancel') {
          this.slideTo(this.current);
        }
      }
      else {
        this.slideTo(this.current);
      }
    };
  }
  optionDidChange(activeSlide) {
    this.slideTo(activeSlide);
  }
  setPan(enabled) {
    this.panEnabled = enabled;
    this.initGesture();
  }
  slideTo(n) {
    let last;
    if (this.differentWidthOfItems) {
      last = Array.from(this.slides)
        .slice(0 - (this.slideCount - this.current))
        .reduce((sum, i) => sum + i.offsetWidth, 0) >= this.slider.offsetWidth
        ? this.slideCount
        : n - 1;
      this.current = n < 0 ? 0 : n >= last ? last : n;
      this.pos = this.current === 0
        ? 0
        : this.operator
          * Array.from(this.slides)
            .slice(0, this.current)
            .reduce((sum, i) => sum + i.offsetWidth, 0);
    }
    else {
      last = this.infinite ? 0 : Math.ceil(this.slideCount - this.itemsPerSlide);
      this.current = n < 0 ? 0 : n >= last ? last : n;
      this.pos = (this.operator * this.current * (!this.verticalPan ? this.slideWidth : this.slideHeight))
        / this.itemsPerSlide;
    }
    this.slider.classList.add('is-animating');
    const prevSlide = this.parent.querySelector(`${this.childrenClassName}.active`);
    prevSlide && prevSlide.classList.remove('active');
    this.slides[this.current] && this.slides[this.current].classList.add('active');
    if (this.showButtons) {
      this.current === last
        ? this.nextBtn && this.nextBtn.classList.add('disabled')
        : this.nextBtn && this.nextBtn.classList.remove('disabled');
      this.current === 0
        ? this.prevBtn && this.prevBtn.classList.add('disabled')
        : this.prevBtn && this.prevBtn.classList.remove('disabled');
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.slider && this.slider.classList.remove('is-animating');
      this.afterSlimSlide.emit({ current: this.current });
    }, this.timing);
    !this.verticalPan ? this.translateY(this.pos) : this.translateX(this.pos);
  }
  init() {
    var _a, _b, _c, _d;
    this.operator = -1;
    this.slides = this.parent.querySelectorAll(this.childrenClassName);
    this.slideCount = this.slides.length;
    this.slideWidth = (_a = this.sliderWidth) !== null && _a !== void 0 ? _a : this.parent.offsetWidth;
    this.slideHeight = (_b = this.sliderHeight) !== null && _b !== void 0 ? _b : this.parent.offsetHeight;
    this.itemWidth = this.slideWidth / this.itemsPerSlide;
    this.itemHeight = this.slideHeight / this.itemsPerSlide;
    this.parent.style.direction = this.direction;
    (_d = (_c = this.slides) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.classList.add('active');
    if (this.slideCount > 4 && this.verticalPan) {
      this.parent.style.marginTop = '23px';
    }
    Array.from(this.slides).forEach((el, k) => {
      el.dataset.item = k.toString();
      if (!this.differentWidthOfItems && this.slideCount > this.itemsPerSlide) {
        this.verticalPan
          ? (el.style.minHeight = `${this.itemHeight}px`)
          : (el.style.minWidth = `${this.itemWidth}px`);
      }
      Array.from(el.querySelectorAll('img')).map((i) => (i.draggable = false));
    });
    this.afterSlimInit.emit({ current: this.current });
  }
  resizeWindow() {
    this.init();
    this.slideTo(0);
  }
  initGesture() {
    if (this.sliderManager) {
      this.sliderManager.destroy();
      this.sliderManager = null;
    }
    if (this.slideCount <= this.itemsPerSlide)
      return;
    const touchAction = !this.panEnabled
      ? { touchAction: 'none' }
      : this.verticalPan
        ? { touchAction: 'pan-x' }
        : { touchAction: 'pan-y' };
    this.sliderManager = new hammer.Manager(this.slider, Object.assign(Object.assign({}, touchAction), { recognizers: [[hammer.Pan, { direction: hammer.DIRECTION_ALL }]] }));
    this.sliderManager.on('panstart panmove panend pancancel panleft panright panup pandown', this.handleSwipe);
    window.addEventListener('resize', () => this.resizeWindow);
  }
  translateY(to) {
    const pos = this.direction === 'rtl' ? to * -1 : to;
    requestAnimationFrame(() => {
      this.slider.style.transform = `translateX(${pos}px)`;
      this.slider.style.webkitTransform = `translateX(${pos}px)`;
    });
  }
  translateX(to) {
    requestAnimationFrame(() => {
      this.slider.style.transform = `translateY(${to}px)`;
      this.slider.style.webkitTransform = `translateY(${to}px)`;
    });
  }
  getCarouselPointers(count) {
    let pointers = [];
    if (this.shortCarouselPagination && count >= 4) {
      pointers = [
        h("a", { class: classnames('pointer', { active: this.current === 0 }) }),
        h("a", { class: classnames('pointer', { active: this.current === 1 }) }),
        h("a", { class: classnames('pointer', { active: this.current > 1 && this.current < count - 1 }) }),
        h("a", { class: classnames('pointer', { active: this.current === count - 1 }) }),
      ];
    }
    else {
      for (let k = 0; k < count - this.itemsPerSlide + 1; k++) {
        pointers.push(h("a", { class: classnames(`pointer_${k}`, { active: this.current === k }), onClick: () => this.slideTo(k) }));
      }
    }
    return pointers;
  }
  updateCurrentPosition(event) {
    this.current = event.detail.current;
  }
  recalculateSlides() {
    this.init();
  }
  recalculateSlidePosition() {
    var _a;
    this.slideWidth = this.parent.offsetWidth;
    this.itemWidth = this.slideWidth / this.itemsPerSlide;
    if ((_a = this.slides) === null || _a === void 0 ? void 0 : _a.length) {
      Array.from(this.slides).forEach((el) => {
        if (!this.differentWidthOfItems && this.slideCount > this.itemsPerSlide) {
          el.style.minWidth = `${this.itemWidth}px`;
        }
      });
    }
    this.pos = (this.operator * this.current * this.slideWidth) / this.itemsPerSlide;
    this.translateY(this.pos);
  }
  componentDidLoad() {
    this.init();
    this.initGesture();
    if (this.current > 0)
      this.slideTo(this.current);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.resizeWindow);
  }
  render() {
    return [
      h("div", { class: "slim-slider-wrapper" }, h("div", { class: classnames('slim-slides', {
          'small-height': this.smallCard,
          vertical: this.verticalPan,
        }), ref: (el) => (this.slider = el) }, h("slot", null))),
      this.showPointers && this.slideCount > this.itemsPerSlide && (h("div", { class: classnames('carousel-pagination', {
          'carousel-pagination__above': this.showThumbnails,
          'small-point': this.smallPoint,
        }) }, this.getCarouselPointers(this.slideCount))),
      this.showButtons && this.slideCount > this.itemsPerSlide && (h("div", { class: classnames({ vertical: this.verticalPan }, 'carousel-buttons') }, h("button", { class: "btn-link prev disabled", onClick: this.goToPrevious, ref: (el) => (this.prevBtn = el) }, this.verticalPan ? (h("pes-icon", { mirror: pesIconMirrorDirection.VERTICAL, size: pesIconSizes.MICRO }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.LARGE, customStyle: { fontSize: '56px' } }, "arrow2_left"))), h("button", { class: "btn-link next", onClick: this.goToNext, ref: (el) => (this.nextBtn = el) }, this.verticalPan ? (h("pes-icon", { size: pesIconSizes.MICRO, customStyle: { fontSize: '40px' } }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.LARGE, customStyle: { fontSize: '56px' }, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))))),
    ];
  }
  get parent() { return getElement(this); }
  static get watchers() { return {
    "activeSlide": ["optionDidChange"],
    "itemsPerSlide": ["recalculateSlides"],
    "sliderWidth": ["recalculateSlidePosition"]
  }; }
};
Slider.style = sliderCss;

export { Slider as pdp_slider };
